export default __webpack_public_path__ + "static/0118-09a431ba75fc61ce689e956a7c0f9eb5.png";